export default {
    date: null,
    type_id: null,
}
